var f = Object.defineProperty, i = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var a = (o, e, t) => e in o ? f(o, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[e] = t, m = (o, e) => {
  for (var t in e || (e = {}))
    d.call(e, t) && a(o, t, e[t]);
  if (r)
    for (var t of r(e))
      s.call(e, t) && a(o, t, e[t]);
  return o;
}, p = (o, e) => i(o, c(e));
import n, { forwardRef as N } from "react";
import l from "../lib/IconBase.mjs";
import w from "../defs/Notepad.mjs";
const R = N((o, e) => /* @__PURE__ */ n.createElement(l, p(m({ ref: e }, o), { weights: w })));
R.displayName = "Notepad";
export {
  R as Notepad
};
